import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectTheme } from 'admin-common';
import { WiSnackBar, WiSnackBarService } from '../../Services/wi-snackBar.service';

/**
 * Renders the snackbar opened through WiSnackBarService. Mounted once, in AppComponent.
 */
@Component({
  selector: 'app-wi-snackbar',
  templateUrl: './wi-snackbar.component.html',
  styleUrls: ['./wi-snackbar.component.scss'],
  standalone: false
})
export class WiSnackbarComponent {
  bank: ProjectTheme = 'WUnivers';
  snackBar$: Observable<WiSnackBar | null>;

  constructor(wiSnackBarService: WiSnackBarService) {
    this.snackBar$ = wiSnackBarService.snackBar$;
  }

  trackById(_: number, snackBar: WiSnackBar): number {
    return snackBar.id;
  }
}
